import { Navigate, useNavigate, useParams } from "react-router-dom";
import JourneyFrame from "@/components/JourneyFrame/JourneyFrame";
import CommentIcon from "@/components/SVGComponents/CommentIcon";
import Dining from "@/components/SVGComponents/Dining";
import Hands from "@/components/SVGComponents/Hands";
import Incognito from "@/components/SVGComponents/Incognito";
import {
  AUTH_ROUTE_PATHS,
  JOURNEY_STEP_KEYS,
  getSignInPath,
  resolveAuthRole,
} from "@/pages/Auth/authConfig";
import { clearSignUpJourneyDraft } from "@/pages/Auth/signUpJourney";
import styles from "./Introduction.module.scss";

const INTRO_STEPS = [
  {
    icon: Hands,
    copy: "We match you with another founder or investor based on intent and fit.",
  },
  {
    icon: Incognito,
    copy: "Details stay private until dinner day so the room feels comfortable and unbiased.",
  },
  {
    icon: Dining,
    copy: "You meet over a carefully curated dinner in a small, high-context setting.",
  },
  {
    icon: CommentIcon,
    copy: "The conversation is guided to help you leave with real context and stronger connections.",
  },
] as const;

const Introduction = () => {
  const navigate = useNavigate();
  const { role: roleParam } = useParams();
  const role = resolveAuthRole(roleParam);

  if (!role) {
    return <Navigate replace to={AUTH_ROUTE_PATHS.roleSelection} />;
  }

  const handleContinue = () => {
    clearSignUpJourneyDraft();
    navigate(getSignInPath());
  };

  return (
    <JourneyFrame
      actionLabel="Continue"
      actionType="button"
      activeStep={JOURNEY_STEP_KEYS.introduction}
      bodyClassName={styles.body}
      onAction={handleContinue}
      role={role}
      title={
        <>
          Here&apos;s How <span className={styles.titleAccent}>BFC</span> Works
        </>
      }
    >
      <div className={styles.cardGrid}>
        {INTRO_STEPS.map(({ icon: Icon, copy }) => (
          <div key={copy} className={styles.infoCard}>
            <div className={styles.iconWrap}>
              <Icon className={styles.icon} />
            </div>
            <p>{copy}</p>
          </div>
        ))}
      </div>
    </JourneyFrame>
  );
};

export default Introduction;
